var map = {
	"./IMG_0974.webp": 893,
	"./IMG_0975.webp": 279,
	"./IMG_0976.webp": 658,
	"./IMG_0977.webp": 422,
	"./IMG_9478.webp": 274,
	"./IMG_9480.webp": 974,
	"./IMG_9481.webp": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;